import { useMutation } from 'react-query';

import { saveCustomCluster as mutationFn } from 'api/endPoints/saveCustomCluster';

export const useMutationSaveSearchWord = () => {
    return useMutation<unknown, QueryError, QueryParams>({
        mutationFn: (params) => mutationFn(params),
    });
};

interface QueryParams {
    customerId: number | undefined;
    paFileMetaDataIds: number[];
    projectId: number | undefined;
    query: string | undefined;
}
